"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'rag.settings.chunkSize.label': 'Chunk Size',
    'rag.settings.chunkSize.description': 'Size of text chunks for indexing (100-2000 characters)',
    'rag.settings.chunkOverlap.label': 'Chunk Overlap',
    'rag.settings.chunkOverlap.description': 'Overlap between chunks to preserve context (0-500 characters)',
    'rag.settings.similarityThreshold.label': 'Similarity Threshold',
    'rag.settings.similarityThreshold.description': 'Minimum similarity score for search results (0.1-1.0)',
    'rag.settings.defaultMaxResults.label': 'Default Max Results',
    'rag.settings.defaultMaxResults.description': 'Default number of search results to return (1-20)',
    'rag.settings.maxResults.label': 'Maximum Results',
    'rag.settings.maxResults.description': 'Maximum number of allowed search results (1-20)',
    'rag.settings.separators.label': 'Text Separators',
    'rag.settings.separators.description': 'Characters used to split text into chunks (comma-separated)',
    'rag.settings.separators.placeholder': 'Enter separators separated by commas',
    'rag.settings.separators.add': 'Add Separator',
    'rag.settings.resetToDefaults.label': 'Reset to Defaults',
    'rag.settings.resetToDefaults.tooltip': 'Reset RAG settings to default values',
};
